(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-cart"]) return;
  try {
    
(function () {
  // This is a JSON-template section, so its real id is template-prefixed
  // (e.g. shopify-section-template--123__page_cart). A section JS block cannot read the
  // Liquid section id, so derive the host + id from the live DOM instead of hardcoding it
  // (the original 'page_cart' guess matched neither the wrapper nor a valid section_id -> silent no-op).
  function getHost() {
    var root = document.querySelector('.hov-cart-page');
    return root ? root.closest('.shopify-section') : null;
  }

  // Re-render this section from the server via the Section Rendering API. Exposed globally so the
  // shared pipeline (assets/ajax-cart.js.liquid renderAllSurfaces) refreshes /cart after any mutation.
  function renderSection() {
    var host = getHost();
    if (!host || !host.id) return Promise.resolve();
    var sid = host.id.replace(/^shopify-section-/, '');
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var trimmed = (html || '').trim();
        var doc = new DOMParser().parseFromString(trimmed, 'text/html');
        var wrapped = doc.getElementById(host.id); // response may or may not include the wrapper
        host.innerHTML = wrapped ? wrapped.innerHTML : trimmed;
        // The re-render wipes the JS-populated cross-sell and the JS-painted coupon list.
        // Re-broadcast cart:updated so both re-inject onto the fresh DOM. (The discount itself now
        // survives the round trip on its own — it lives on the cart, so Liquid renders it.)
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {});
  }
  window.hovRenderPageCartSection = renderSection;

  // ── "You may also like" — Shopify native Product Recommendations API (the theme's established
  //    cross-sell source). Caches per seed product; re-paints (no re-fetch) after section re-renders.
  (function () {
    var recProducts = null, cachedSeed = null;

    function money(c) { return '₹' + (c / 100).toFixed(2); }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
      });
    }
    function cartProductIds() {
      var ids = [], nodes = document.querySelectorAll('#hov-cart-page-lines [data-product-id]');
      for (var i = 0; i < nodes.length; i++) { ids.push(parseInt(nodes[i].getAttribute('data-product-id'), 10)); }
      return ids;
    }
    function cardHTML(p) {
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var v = p.variants && p.variants[0];
      return '<div class="hov-cart-page__cs-card">' +
        '<a class="hov-cart-page__cs-imglink" href="' + esc(p.url) + '">' +
          '<img class="hov-cart-page__cs-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
        '<p class="hov-cart-page__cs-title">' + esc(p.title) + '</p>' +
        '<p class="hov-cart-page__cs-price">' + money(p.price) + '</p>' +
        '<button type="button" class="hov-cart-page__cs-add"' +
          (v ? ' data-variant-id="' + v.id + '"' : ' disabled') + '>+ Add</button>' +
      '</div>';
    }
    function paint() {
      var section = document.querySelector('[data-crosssell]');
      var scroll = document.querySelector('[data-crosssell-scroll]');
      if (!section || !scroll || !recProducts) return;
      var inCart = cartProductIds();
      var show = recProducts.filter(function (p) { return inCart.indexOf(p.id) === -1; }).slice(0, 8);
      if (!show.length) { section.hidden = true; return; }
      scroll.innerHTML = show.map(cardHTML).join('');
      section.hidden = false;
    }
    function load() {
      var section = document.querySelector('[data-crosssell]');
      var scroll = document.querySelector('[data-crosssell-scroll]');
      if (!section || !scroll) return; // empty cart — nothing to render
      var seed = scroll.getAttribute('data-seed-product');
      if (!seed) { section.hidden = true; return; }
      if (recProducts && cachedSeed === seed) { paint(); return; } // re-inject after a re-render, no re-fetch
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(seed) + '&limit=10&intent=related')
        .then(function (r) { return r.json(); })
        .then(function (data) { recProducts = (data && data.products) || []; cachedSeed = seed; paint(); })
        .catch(function () { section.hidden = true; });
    }

    // Delegated so the handler survives section re-renders (cards are re-created on each paint).
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.hov-cart-page__cs-add[data-variant-id]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          btn.textContent = 'Added ✓';
          // Reuse the shared render path — refreshes drawer, header badge AND this page's totals.
          if (typeof window.renderAllSurfaces === 'function') window.renderAllSurfaces(cart);
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
        })
        .catch(function () {
          btn.textContent = label; btn.disabled = false;
          if (typeof window.hovShowCartToast === 'function') window.hovShowCartToast('Could not add item — please try again.');
        });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', load);
    } else { load(); }
    document.addEventListener('cart:updated', load);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-newsletter-v1"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

const params = new URLSearchParams(window.location.search);
const hash = window.location.hash;

const footerSuccess = document.querySelector(".footer_success");

if (params.get("customer_posted") === "true" && hash === "#contact_form") {

  if (footerSuccess) {
    footerSuccess.style.display = "block";
  }

}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-v3"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
    $('body').on('submit', '.ajax-cart-form', function(e) {
        // The drawer's ajax-cart.js already handles every /cart/add form (and fires first). Without
        // this guard each grid click posted the add twice and rebuilt the drawer a third time.
        if (e.isDefaultPrevented() || window.ajaxCart) return;
        e.preventDefault();
        var form = $(this);
        var productId = form.find('input[name="id"]').val();
        doAjaxAddToCart(productId,1,'','');
    });
});


  } catch(e) { console.error(e); }
})();
})();
